<template>
    <section class="service-box">
        <div class="container-fluid p-0">
            <ol class="service-horizontal">
                <li v-for="service in services" :key="service.id" :class="{ active: service.id == activeService }">
                    <a v-if="service.id == activeService" href="#" key="active_service"><span class="service-text">{{ service.name }}</span></a>
                    <a :href="service.link" v-else key="normal_service"><span class="service-text">{{ service.name }}</span></a>
                </li>
            </ol>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'ServiceBox',
        props: {
            activeService: Number
        },
        data() {
            return {
                services: [
                    {id: 1, name: "海外SNS運用サービス", link: '/global/service/global-sns',},
                    {id: 2, name: "EC支援サービス", link: '/global/service/global-e-commerce'},
                    {id: 3, name: "広告配信", link: '/global/service/global-ad'},
                    {id: 4, name: "海外プロモーション", link: '/global/service/inbound'},
                    {id: 5, name: "Webサイト", link: '/global/service/website-development'},
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    ol.service-horizontal {
        counter-reset: item;
        list-style-type: none;
        font-size: 28px;
        letter-spacing: 1.12px;
        line-height: 90px;
        font-weight: bold;
        color: #ddd;
        display: table;
        width: 100%;
        padding-left: 0;
        margin-bottom: 0;
        >li {
            display: block;
            display: table-cell;
            width: 20%;
            padding: 3rem 2.5rem 5rem;
            border: 1px solid #ddd;
            border-right: none;
            color: #000 !important;
            font-size: 20px;
            letter-spacing: 0.8px;
            line-height: 30px;
            position: relative;
            background: linear-gradient(to left, #FFF 50%, #FFBC07 50%) right;
            background-size: 201%;
            transition: .2s ease-out;
            &:before {
                content: counter(item,decimal-leading-zero) "/";
                counter-increment: item;
                font-size: 16px;
                width: 100px;
            }
            &:not(.active) {
                &:hover {
                    span {
                        &:after {
                            width: 71px;
                        }
                    }
                }
                span {
                    &:after {
                        width: 71px;
                        height: 13px;
                        top: calc(100% + 25px);
                        left: calc(100% - 72px);
                    }
                }
            }
            a {
                &:hover {
                    color: inherit;
                }
            }
            span {
                position: relative;
                width: calc(100% - 50px);
                display: inline-block;
                padding: 30px 0;
                &:after {
                    position: absolute;
                    content: "";
                    display: block;
                    width: 0;
                    height: 13px;
                    top: 30%;
                    left: 100%;
                    background: url(../../assets/icons/arrow-right-dark.svg) no-repeat right center;
                    -webkit-transition: width 0.2s;
                    -moz-transition: width 0.2s;
                    -o-transition: width 0.2s;
                    -ms-transition: width 0.2s;
                    transition: width 0.2s;
                }
            }
            &:hover {
                &:not(.active) {
                    background-position: left;
                }
            }
            &:after {
                content: "";
                display: block;
                border-bottom: 1px solid #707070;
            }
        }
        >li.active {
            color: #000;
            background: #f8f8f8;
        }
        li {
            &:before {
                width: 50px;
                display: inline-block;
            }
        }
    }

    @media screen and (max-width: 991px) {
        ol.service-horizontal {
            > li {
                font-family: 'Noto Sans JP', sans-serif;
                width: 100%;
                display: block;
                padding: .8rem 5rem;
                background: #FFF;
                background-size: 100%;

                &:after {
                    border-bottom: none;
                }
                &.active {
                    color: #000;
                    background: #f8f8f8;
                }
                span {
                    width: calc(100% - 121px);
                    &:after {
                        top: 40% !important;
                        left: 100% !important;
                        width: 71px;
                        height: 13px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 414px) {
        ol.service-horizontal {
            > li {
                padding: .8rem 2.5rem;
                font-size: 18px;
                &:before {
                    width: 45px;
                }
                span {
                    width: calc(100% - 90px);
                    &:after {
                        width: 60px!important;
                    }
                }
            }
        }
    }
</style>
